// src/components/protection/AuthWrapper.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkingToken, setCheckingToken] = useState(true);

  const logout = () => {
    localStorage.clear();
    if (location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
  };

  const checkTokenValidity = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp && decoded.exp > now;
    } catch (err) {
      console.error("❌ Token tidak valid:", err);
      return false;
    }
  };

  useEffect(() => {
    // 🚦 Cek saat pertama kali halaman dimuat
    if (!checkTokenValidity()) {
      logout();
    }
    setCheckingToken(false);

    // 🔁 Cek token setiap 5 detik
    const intervalId = setInterval(() => {
      const token = localStorage.getItem("token"); // ambil token TERBARU
      if (!token) {
        logout();
        return;
      }
      try {
        const decoded = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000);
        if (decoded.exp && decoded.exp <= now) {
          console.log("⏰ Token expired, auto logout...");
          logout();
        }
      } catch (err) {
        console.error("❌ Error decoding token:", err);
        logout();
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [location.pathname, navigate]);

  if (checkingToken) {
    return (
      <div className="pt-12 font-semibold text-center text-green-800">
        <p>🔐 Mengecek sesi login Anda...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
